import { useEffect } from 'react';

import { useCaptureException } from '@zenbusiness/application-commons-logging';

import { useInitialDataContext } from '#client/InitialDataContext';

import useToastContext from './useToastContext';

export default function useMfaStatus() {
  const { error, data, loading: isFetchingMfaStatus, refetch } = useInitialDataContext();
  const { createCommonErrorToast } = useToastContext();
  const captureException = useCaptureException();

  const { isEnabled, isEnrolled, isValidMfa } = data?.mfaStatus || {};

  useEffect(() => {
    const ignoreHttpStatusCode = error?.statusCode === 500;
    const errorMessage = error?.message;
    // If error is 500, we'll log warning, other will be as error
    if (error) {
      createCommonErrorToast();
      captureException(new Error(errorMessage), {
        level: ignoreHttpStatusCode ? 'warning' : 'error'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  // isEnrolled: false & isEnabled: false => enable MFA => redirect
  // isEnrolled: true & isEnabled: false => enable MFA => redirect
  // isEnrolled: true & isEnabled: true & isValidMfa: false => redirect
  return {
    refetch,
    error,
    isEnabled,
    isEnrolled,
    isValidMfa,
    isFetchingMfaStatus,
    shouldForceRedirect: isEnrolled && isEnabled && !isValidMfa,
    shouldEnableMfaFirst: (!isEnrolled && !isEnabled) || (isEnrolled && !isEnabled)
  };
}
